import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { WOODCRAFT, requestQuote } from "@/lib/site";
import { Reveal, Overline } from "./Reveal";
import { PhotoSlot } from "./PhotoSlot";

const Card = ({ item, i }) => (
  <motion.article data-testid={`woodcraft-card-${item.key}`}
    initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay: (i % 2) * 0.12, ease: [0.22, 1, 0.36, 1] }}
    className={`group ${i % 2 ? "sm:mt-10" : ""}`}>
    <div className="chamfer-sm overflow-hidden">
      {item.photo ? (
        <img src={item.photo} alt={`${item.title} by TSR Industry`} loading="lazy" data-testid={`woodcraft-img-${item.key}`}
          className="aspect-[3/2] w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
      ) : (
        <PhotoSlot art={item.key} className="aspect-[4/5]" testId={`woodcraft-photo-${item.key}`} />
      )}
    </div>
    <div className="mt-5 flex items-start justify-between gap-4">
      <div>
        <p className="font-mono-tech text-xs text-[var(--gold-text)]">0{i + 1} / Teak & Wood</p>
        <h3 className="font-display text-2xl font-bold tracking-tight mt-1.5">{item.title}</h3>
        <p className="mt-2 text-sm sm:text-base text-slate-700 leading-relaxed">{item.text}</p>
      </div>
      <button data-testid={`woodcraft-quote-btn-${item.key}`} onClick={() => requestQuote(item.title === "Pooja Mandirs" ? "Pooja Mandir" : item.title)}
        aria-label={`Request a quote for ${item.title}`}
        className="shrink-0 h-12 w-12 rounded-full border border-slate-400 grid place-items-center hover:bg-[#0e1116] hover:text-[#e8c36a] hover:border-[#0e1116] transition-colors">
        <ArrowUpRight className="h-5 w-5" />
      </button>
    </div>
  </motion.article>
);

export const Woodcraft = () => (
  <section id="woodcraft" data-testid="woodcraft-section" className="relative py-24 sm:py-32 bg-[var(--sand)]">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16">
      <div className="lg:col-span-4">
        <div className="lg:sticky lg:top-32">
          <Reveal>
            <Overline>Teak woodcraft</Overline>
            <h2 className="font-display font-bold tracking-tight text-4xl sm:text-5xl lg:text-6xl mt-5 leading-[0.98]">
              Devotion,<br /><span className="text-gold-grad">in teak.</span>
            </h2>
            <p className="mt-6 text-base md:text-lg text-slate-700 leading-relaxed">
              The same CNC precision that cuts steel shapes our woodwork — lotus flowers, pooja mandirs, carved panels and furniture made for Indian homes and temples.
            </p>
            <button data-testid="woodcraft-cta-btn" onClick={() => requestQuote("Pooja Mandir")}
              className="mt-8 inline-flex items-center gap-2 h-12 px-6 rounded-full bg-[#0e1116] text-white font-semibold hover:bg-black transition-colors">
              Plan a custom piece <ArrowUpRight className="h-4 w-4 text-[#e8c36a]" />
            </button>
          </Reveal>
        </div>
      </div>
      <div className="lg:col-span-8 grid sm:grid-cols-2 gap-x-6 gap-y-12">
        {WOODCRAFT.map((it, i) => <Card key={it.key} item={it} i={i} />)}
      </div>
    </div>
  </section>
);
